import React, { useState, useEffect, useContext } from 'react';
import { Stack, Typography, Card, CardContent, CardHeader, Button, Box } from '@mui/material';
import { translate as t } from 'hooks/useTranslations';
import { neutral } from '_lex/_foundations/phxColors';
import { Edit as EditIcon } from '@mui/icons-material';
import { useNavigate, useParams } from 'react-router-dom';
import { DTBLibraryContext } from '../../context';

interface PolicyReferences {
  name: string;
}

interface PolicyReferencesProps {
  contentReferences?: PolicyReferences[];
}

const PolicyReferences: React.FC<PolicyReferencesProps> = ({ contentReferences }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { handleSave, editedData } = useContext(DTBLibraryContext);

  const handleEditClick = async () => {
    await handleSave(false);
    navigate(`/admin/dtbs/library/${id}/content-reference`);
  };

  return (
    <Card className='lex-drawer-card'>
      <CardHeader
        title={t('dtbs.library.detail.contentReferences.title')}
        action={
          <Button
            variant='outlined'
            color='neutral'
            size='small'
            className='xs icon-only'
            startIcon={<EditIcon />}
            onClick={handleEditClick}
            disabled={!editedData?.manual?.id}
          />
        }
      />
      <CardContent>
        {contentReferences && contentReferences.length > 0 ? (
          <Stack spacing={1}>
            {contentReferences.map((ref, index) => (
              <Typography
                key={index}
                variant='bodyMd'
                sx={{ minWidth: 0, whiteSpace: 'normal' }}
              >
                {ref.name}
              </Typography>
            ))}
          </Stack>
        ) : (
          <Typography
            variant='bodyMd'
            color={neutral[400]}
            sx={{ minWidth: 0, whiteSpace: 'normal' }}
          >
            {!editedData?.manual?.id
              ? t('dtbs.library.detail.contentReferences.noManualEmpty')
              : t('dtbs.library.detail.contentReferences.empty')}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};

export default PolicyReferences;
